import { useField, ErrorMessage } from 'formik';

export const MyCheckBox = ({ label, ...props }) => {

  const [field] = useField({ ...props, type: 'checkbox' });

  return (
    <div className="mb-3 row">
      <div className="form-check">
        <input className="form-check-input " type="checkbox" id={label} {...field} {...props} />
        <label className="form-check-label" htmlFor={label}>{label}</label>
        <ErrorMessage name={props.name} component="span" />
      </div>
    </div>
  )
}